(function() {
  'use strict';

  var STORAGE_PREFIX = 'hero-ab-test:';
  var EXPOSURE_PREFIX = 'hero-ab-test:exposure:';
  var CLICK_NAVIGATION_DELAY_MS = 150;

  function safeStorage(type) {
    try {
      return window[type];
    } catch (e) {
      return null;
    }
  }

  function getQueryParam(name) {
    try {
      return new URLSearchParams(window.location.search).get(name);
    } catch (e) {
      return null;
    }
  }

  function hashString(value) {
    var hash = 2166136261;
    var input = String(value || '');
    for (var i = 0; i < input.length; i += 1) {
      hash ^= input.charCodeAt(i);
      hash += (hash << 1) + (hash << 4) + (hash << 7) + (hash << 8) + (hash << 24);
    }
    return Math.abs(hash >>> 0);
  }

  function detectDevice() {
    return window.innerWidth <= 768 ? 'mobile' : 'desktop';
  }

  function getStableVisitorId() {
    var storage = safeStorage('localStorage');
    var key = STORAGE_PREFIX + 'visitor-id';
    var existing = storage && storage.getItem(key);
    if (existing) return existing;

    var source = '';

    try {
      source = window.ShopifyAnalytics &&
        window.ShopifyAnalytics.meta &&
        window.ShopifyAnalytics.meta.page &&
        window.ShopifyAnalytics.meta.page.customerId
        ? String(window.ShopifyAnalytics.meta.page.customerId)
        : '';
    } catch (e) {}

    if (!source) {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        source = window.crypto.randomUUID();
      } else {
        source = [
          Date.now(),
          Math.random(),
          navigator.userAgent || '',
          window.location.host || ''
        ].join('|');
      }
    }

    var generated = 'anon_' + source;
    if (storage) storage.setItem(key, generated);
    return generated;
  }

  function resolveVariant(root) {
    var existingVariant = root.getAttribute('data-resolved-variant') || '';
    if (existingVariant === 'control' || existingVariant === 'test') {
      return existingVariant;
    }

    var sectionConfig = getAssignmentConfig(root);

    if (sectionConfig.forceVariant === 'control' || sectionConfig.forceVariant === 'test') {
      return sectionConfig.forceVariant;
    }

    if (sectionConfig.isDesignMode && (sectionConfig.previewMode === 'control' || sectionConfig.previewMode === 'test')) {
      return sectionConfig.previewMode;
    }

    var requestedVariant = getQueryParam(sectionConfig.overrideParam);
    if (requestedVariant === 'control' || requestedVariant === 'test') {
      return requestedVariant;
    }

    if (!sectionConfig.experimentKey) return 'control';

    var visitorId = getStableVisitorId();
    var bucket = hashString(sectionConfig.experimentKey + '|' + visitorId) % 100;
    var allocation = Number.isFinite(sectionConfig.allocation) ? sectionConfig.allocation : 50;
    if (allocation < 0) allocation = 0;
    if (allocation > 100) allocation = 100;

    return bucket < allocation ? 'test' : 'control';
  }

  function getAssignmentConfig(root) {
    var rawConfig = root.getAttribute('data-assignment-config') || '';
    var parsedConfig = {};

    if (rawConfig) {
      try {
        parsedConfig = JSON.parse(rawConfig);
      } catch (e) {
        parsedConfig = {};
      }
    }

    return {
      experimentKey: parsedConfig.experimentKey || root.getAttribute('data-experiment-key') || '',
      allocation: parseInt(parsedConfig.allocation != null ? parsedConfig.allocation : root.getAttribute('data-allocation'), 10),
      overrideParam: parsedConfig.overrideParam || root.getAttribute('data-override-param') || 'hero_ab_variant',
      previewMode: parsedConfig.previewMode || root.getAttribute('data-preview-mode') || 'auto',
      forceVariant: parsedConfig.forceVariant || root.getAttribute('data-force-variant') || '',
      isDesignMode: parsedConfig.isDesignMode === true || root.getAttribute('data-design-mode') === 'true'
    };
  }

  function getAssignmentMeta(root, variant) {
    var existingBucket = root.getAttribute('data-assignment-bucket');
    var existingAllocation = root.getAttribute('data-assignment-allocation');
    if (existingAllocation !== null) {
      return {
        variant: variant,
        bucket: existingBucket || '',
        allocation: existingAllocation
      };
    }

    var sectionConfig = getAssignmentConfig(root);
    var experimentKey = sectionConfig.experimentKey;
    var allocation = sectionConfig.allocation;
    var normalizedAllocation = Number.isFinite(allocation) ? allocation : 50;
    if (normalizedAllocation < 0) normalizedAllocation = 0;
    if (normalizedAllocation > 100) normalizedAllocation = 100;

    var bucket = '';
    if (experimentKey) {
      bucket = hashString(experimentKey + '|' + getStableVisitorId()) % 100;
    }

    return {
      variant: variant,
      bucket: bucket,
      allocation: normalizedAllocation
    };
  }

  function setImageSource(image, url, srcset, alt) {
    if (!image || !url) return;

    if (image.getAttribute('src') !== url) {
      image.setAttribute('src', url);
    }

    if (image.classList.contains('lazyloadt4s')) {
      image.setAttribute('data-src', url);
      if (srcset) image.setAttribute('data-srcset', srcset);
      image.removeAttribute('srcset');
      image.classList.remove('lazyloadt4s');
      image.classList.add('lazyloadt4sed');
    }

    if (srcset && image.getAttribute('srcset') !== srcset) {
      image.setAttribute('srcset', srcset);
    }
    if (alt && image.getAttribute('alt') !== alt) {
      image.setAttribute('alt', alt);
    }
  }

  function isCurrentDeviceImage(image) {
    if (!image) return false;
    var isMobileImage = image.hasAttribute('data-hero-image-mobile');
    return detectDevice() === 'mobile' ? isMobileImage : !isMobileImage;
  }

  function markSlideReady(slide) {
    if (!slide) return;
    slide.classList.add('hero-ab-slide-ready');
  }

  function finalizeSlideImage(slide, image) {
    if (!image) {
      markSlideReady(slide);
      return;
    }

    if (!isCurrentDeviceImage(image)) return;

    if (image.complete && image.naturalWidth > 0) {
      markSlideReady(slide);
      return;
    }

    var onReady = function() {
      image.removeEventListener('load', onReady);
      image.removeEventListener('error', onReady);
      markSlideReady(slide);
    };

    image.addEventListener('load', onReady, { once: true });
    image.addEventListener('error', onReady, { once: true });
  }

  function buildEventName(root, type) {
    var explicit = root.getAttribute('data-event-name-' + type) || '';
    if (explicit) return explicit;

    var suffix = root.getAttribute('data-event-suffix') || '';
    var baseName = type === 'impression' ? 'hero_ab_slide_impression' : 'hero_ab_slide_click';
    return suffix ? baseName + '_' + suffix : baseName;
  }

  function shouldDelayNavigation(event, link) {
    if (!link || !link.href) return false;
    if (event.defaultPrevented) return false;
    if (event.button && event.button !== 0) return false;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return false;
    if (link.hasAttribute('download')) return false;

    var target = (link.getAttribute('target') || '').toLowerCase();
    if (target && target !== '_self') return false;

    var href = link.getAttribute('href') || '';
    if (!href || href.charAt(0) === '#') return false;
    if (/^(mailto:|tel:|javascript:)/i.test(href)) return false;

    return true;
  }

  function continueNavigation(link) {
    var targetUrl = link.href;
    if (!targetUrl) return;
    window.setTimeout(function() {
      window.location.href = targetUrl;
    }, CLICK_NAVIGATION_DELAY_MS);
  }

  function maybeTrackExposure(root, slide) {
    if (!slide || slide.getAttribute('data-exposure-tracked') === 'true') return;

    var experimentKey = slide.getAttribute('data-experiment-key') || root.getAttribute('data-experiment-key') || '';
    var slideId = slide.getAttribute('data-slide-id') || '';
    var variant = slide.getAttribute('data-active-variant') || 'control';
    var storage = safeStorage('sessionStorage');
    var eventName = buildEventName(root, 'impression');
    var storageKey = EXPOSURE_PREFIX + eventName + ':' + experimentKey + ':' + slideId + ':' + variant;

    if (storage && storage.getItem(storageKey) === '1') {
      slide.setAttribute('data-exposure-tracked', 'true');
      return;
    }

    var payload = {
      experiment_key: experimentKey,
      experiment_name: root.getAttribute('data-experiment-name') || experimentKey,
      event_name: eventName,
      variant: variant,
      bucket: slide.getAttribute('data-assignment-bucket') || '',
      allocation: slide.getAttribute('data-assignment-allocation') || root.getAttribute('data-allocation') || '',
      slide_id: slideId,
      slide_title: slide.getAttribute('data-slide-title') || '',
      section_id: root.getAttribute('data-section-id') || '',
      device: detectDevice(),
      page_url: window.location.href,
      page_type: document.body ? document.body.className : ''
    };

    OpenPanel.track(eventName, payload);
    slide.setAttribute('data-exposure-tracked', 'true');
    if (storage) storage.setItem(storageKey, '1');
  }

  function bindExposure(root) {
    if (!('IntersectionObserver' in window)) {
      var selected = root.querySelector('.t4s-slideshow-item');
      maybeTrackExposure(root, selected);
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting || entry.intersectionRatio < 0.5) return;
        maybeTrackExposure(root, entry.target);
      });
    }, {
      threshold: [0.5]
    });

    root.querySelectorAll('[data-hero-ab-slide]').forEach(function(slide) {
      observer.observe(slide);
    });
  }

  function bindClicks(root) {
    root.addEventListener('click', function(event) {
      var target = event.target.closest('[data-hero-ab-click]');
      if (!target) return;

      var slide = target.closest('[data-hero-ab-slide]');
      if (!slide) return;

      var eventName = buildEventName(root, 'click');

      var payload = {
        experiment_key: slide.getAttribute('data-experiment-key') || root.getAttribute('data-experiment-key') || '',
        experiment_name: root.getAttribute('data-experiment-name') || root.getAttribute('data-experiment-key') || '',
        event_name: eventName,
        variant: slide.getAttribute('data-active-variant') || 'control',
        bucket: slide.getAttribute('data-assignment-bucket') || '',
        allocation: slide.getAttribute('data-assignment-allocation') || root.getAttribute('data-allocation') || '',
        slide_id: slide.getAttribute('data-slide-id') || '',
        slide_title: slide.getAttribute('data-slide-title') || '',
        click_target: target.getAttribute('data-hero-ab-click') || 'slide',
        destination_url: target.getAttribute('href') || '',
        device: detectDevice(),
        page_url: window.location.href
      };

      OpenPanel.track(eventName, payload);

      if (shouldDelayNavigation(event, target)) {
        event.preventDefault();
        continueNavigation(target);
      }
    }, true);
  }

  function applyVariantToSlide(root, slide, variant) {
    var mobileImage = slide.querySelector('[data-hero-image-mobile]');
    var desktopImage = slide.querySelector('[data-hero-image-desktop]');

    var mobileUrl = slide.getAttribute('data-' + variant + '-mobile-url') || '';
    var desktopUrl = slide.getAttribute('data-' + variant + '-desktop-url') || '';
    var mobileSrcset = slide.getAttribute('data-' + variant + '-mobile-srcset') || '';
    var desktopSrcset = slide.getAttribute('data-' + variant + '-desktop-srcset') || '';
    var mobileAlt = slide.getAttribute('data-' + variant + '-mobile-alt') || slide.getAttribute('data-default-alt') || '';
    var desktopAlt = slide.getAttribute('data-' + variant + '-desktop-alt') || slide.getAttribute('data-default-alt') || '';
    setImageSource(mobileImage, mobileUrl, mobileSrcset, mobileAlt);
    setImageSource(desktopImage, desktopUrl, desktopSrcset, desktopAlt);

    slide.setAttribute('data-active-variant', variant);

    if (detectDevice() === 'mobile') {
      finalizeSlideImage(slide, mobileImage);
    } else {
      finalizeSlideImage(slide, desktopImage);
    }
  }

  function initSection(root) {
    var variant = resolveVariant(root);
    var assignmentMeta = getAssignmentMeta(root, variant);

    root.setAttribute('data-resolved-variant', assignmentMeta.variant);
    root.setAttribute('data-assignment-bucket', assignmentMeta.bucket);
    root.setAttribute('data-assignment-allocation', assignmentMeta.allocation);

    root.querySelectorAll('[data-hero-ab-slide]').forEach(function(slide) {
      var slideMode = slide.getAttribute('data-slide-mode') || 'disabled';
      var activeVariant = slideMode === 'enabled' ? assignmentMeta.variant : 'control';
      slide.setAttribute('data-assignment-bucket', assignmentMeta.bucket);
      slide.setAttribute('data-assignment-allocation', assignmentMeta.allocation);
      applyVariantToSlide(root, slide, activeVariant);
    });

    root.classList.add('hero-ab-test-ready');
    bindExposure(root);
    bindClicks(root);

    if (document.documentElement && document.documentElement.classList.contains('shopify-design-mode')) {
      document.addEventListener('shopify:block:select', function(event) {
        var selectedSlide = event.target && event.target.closest ? event.target.closest('[data-hero-ab-slide]') : null;
        if (selectedSlide && root.contains(selectedSlide)) {
          maybeTrackExposure(root, selectedSlide);
        }
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-hero-ab-test]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
